<template>
  <div v-if="hasActivityContent" class="activity-message-wrap">
    <div
      class="activity-content text-xs text-center py-2 px-3 my-2 mx-auto rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"
    >
      {{ formattedContent }}
    </div>
  </div>

  <div v-else />
</template>

<script>
export default {
  name: 'ActivityMessage',
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    formattedContent() {
      return this.message.processed_message_content || this.message.content;
    },
    hasActivityContent() {
      const content =
        this.message.processed_message_content || this.message.content;

      // Special case: Hide the "The support agent ended the chat" notification
      // from clients as it's not useful for end users and creates unnecessary
      // noise in the chat widget (COM-2447)
      if (content && content.includes('The support agent ended the chat')) {
        return false;
      }

      return content && content.trim() !== '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables.scss';

.activity-message-wrap {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: $space-small 0;

  .activity-content {
    max-width: 80%;
    display: inline-block;
  }
}
</style>
